<template>
  <v-container fluid fill-height class="px-0">
    <v-row class="flex-wrap">
      <v-col
        :class="['left-column', { collapsed: collapsed }]"
        :cols="collapsed ? 1 : 12"
        :xl="collapsed ? 1 : 4"
        :lg="collapsed ? 1 : 4"
        :md="collapsed ? 1 : 4"
        :sm="collapsed ? 1 : 12"
        :xs="collapsed ? 1 : 12"
        class="d-flex flex-column"
      >
        <v-expand-x-transition>
          <v-card>
            <v-btn @click="toggleCollapse" class="text-center" color="primary">
              <v-icon>
                {{ collapsed ? "mdi-chevron-right" : "mdi-chevron-left" }}
              </v-icon>
            </v-btn>
            <div :class="['collapse-transition', { collapsed: collapsed }]">
              <v-card v-show="!collapsed">
                <!-- Contenido del calendario -->

                <ProductionOrderDetail />
              </v-card>
            </div>
          </v-card>
        </v-expand-x-transition>
      </v-col>
      <v-col
        :class="['right-column', { collapsed: collapsed }]"
        :cols="collapsed ? 11 : 12"
        :xl="collapsed ? 11 : 8"
        :lg="collapsed ? 11 : 8"
        :md="collapsed ? 11 : 8"
        :sm="collapsed ? 11 : 12"
        :xs="collapsed ? 11 : 12"
        class="d-flex flex-column"
      >
        <v-card class="rounded-lg flex d-flex flex-column">
          <v-card-text>
            <v-row>
              <v-col>
                <ProductionOrderList />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// components
import ProductionOrderDetail from "@/components/dashboard/production-orders/ProductionOrderDetail";
import ProductionOrderList from "@/components/dashboard/production-orders/ProductionOrderList";
// date library
import dayjs from "dayjs";
export default {
  components: {
    ProductionOrderDetail,
    ProductionOrderList,
  },
  data: () => ({
    collapsed: false,
  }),
  mounted() {},
  methods: {
    toggleCollapse() {
      this.collapsed = !this.collapsed;
    },
    dateFormat(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY - HH:mm")} hrs`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
    dateFormatShort(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY")}`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
  },
};
</script>

<style scoped>
.left-column {
  transition: flex 0.3s ease-in-out;
}

.collapsed {
  flex: 0;
}

.right-column {
  transition: flex 0.3s ease-in-out;
  flex-grow: 1;
}

@media (max-width: 1200px) {
  .right-column.collapsed {
    flex: 1;
  }
}
</style>
